import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { message } from "antd";
import { getProjectsListV2 } from "../../api";

const useFetchProjects = (
  isCommercialDashboard,
  isPartnerships,
  isGCCProject,
  isFemtechAnalyticsProject,
  isEcosystemProject,
  isPartnershipsSandbox,
  isBizdevSandbox,
  isQuantumTechProducts,
  isHealthTechProducts
) => {
  const [querySearch, setQuerySearch] = useState("");
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const sectorName = useSelector((state) => state.notificationsData.sectorName);

  useEffect(() => {
    setProjects([]);
    setPage(1);
    setHasMore(true);
  }, [sectorName, isCommercialDashboard, isPartnerships, isGCCProject, isFemtechAnalyticsProject, isEcosystemProject, isPartnershipsSandbox, isBizdevSandbox, isQuantumTechProducts, isHealthTechProducts]);

  useEffect(() => {
    let debounceTimeout;

    if (querySearch) {
      debounceTimeout = setTimeout(() => {
        loadProjects(1, querySearch);
      }, 2000);
    } else {
      loadProjects(page, querySearch);
    }

    return () => {
      if (debounceTimeout) {
        clearTimeout(debounceTimeout);
      }
    };
  }, [querySearch, sectorName, page]);

  const loadProjects = (page, querySearch) => {
    setLoading(true);

    const query = {
      page,
      querySearch,
      isCommercialDashboard,
      isPartnerships,
      isGCCProject,
      isFemtechAnalyticsProject,
      isEcosystemProject,
      isPartnershipsSandbox,
      isBizdevSandbox,
      isQuantumTechProducts,
      isHealthTechProducts,
      sector: sectorName,
      platform: window.location.origin
    };

    getProjectsListV2(query)
      .then(({ data }) => {
        if (data?.projects?.docs) {
          const newProjects = data?.projects?.docs;
          setProjects((prev) => {
            return [...new Set([...prev, ...newProjects])];
          });
          setHasMore(data?.projects?.hasNextPage);
        } else {
          setHasMore(false);
        }
      })
      .catch(() => {
        message.error("Something went wrong, Please try again !!");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const searchFilter = (e) => {
    setProjects([]);
    setQuerySearch(e.target.value);
    setPage(1);
  };

  const fetchMoreData = () => {
    setPage((prevPage) => prevPage + 1);
  };

  return {
    projects,
    loading,
    hasMore,
    searchFilter,
    fetchMoreData,
    querySearch
  };
};

export default useFetchProjects;
